import { Popover, Typography } from '@mui/material';
import { FC } from 'react';

interface ITablePopover {
  anchorEl: HTMLElement | null;
  text: string;
  onPopperClose: () => void;
  id?: string;
  greyBackground?: boolean;
}

export const TablePopover: FC<ITablePopover> = ({
  anchorEl,
  text,
  onPopperClose,
  id = 'mouse-over-popover',
  greyBackground = false
}) => {
  return (
    <Popover
      id={id}
      open={!!anchorEl}
      anchorEl={anchorEl}
      disableRestoreFocus
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }}
      sx={{
        pointerEvents: 'none'
      }}
      onClose={onPopperClose}
    >
      <Typography
        sx={{
          padding: '.5rem',
          backgroundColor: theme => greyBackground && theme.palette.grey[200]
        }}
        variant="body1"
      >
        {text}
      </Typography>
    </Popover>
  );
};
